import { LIVELY_KEYWORD, LIVELY_TALK_DRIVER_URL, NATURAL_KEYWORD, NATURAL_TALK_DRIVER_URL } from '@/constants';
import LivelyTalkIcon from '@/images/movements/icons/talkLivelyIcon.svg';
import NaturalTalkIcon from '@/images/movements/icons/talkNaturalIcon.svg';
import { useClipPresenterDrivers } from '@/pages/AdvancedEditor/hooks/useClipPresenterDrivers';
import { getClipPresenterDrivers } from '@/services/api';
import { IClipDriver, Presenter, VideoType } from '@d-id/types';
import { useMemo } from 'react';

const SP_MOVEMENTS = [
    { name: NATURAL_KEYWORD, thumbnail_url: NaturalTalkIcon, driver_id: NATURAL_TALK_DRIVER_URL, type: VideoType.TALK },
    { name: LIVELY_KEYWORD, thumbnail_url: LivelyTalkIcon, driver_id: LIVELY_TALK_DRIVER_URL, type: VideoType.TALK },
] as IClipDriver[];

export const usePresenterDrivers = (avatar: Presenter | undefined) => {
    const { data = [] } = useClipPresenterDrivers(avatar);

    const presenterDrivers = useMemo(() => {
        if (!avatar) {
            return [];
        }

        if (avatar?.type === VideoType.TALK) {
            return [...SP_MOVEMENTS].sort((a, b) => (b?.name || '').localeCompare(a.name || ''));
        }

        return data.sort((a, b) => (b?.name || '').localeCompare(a.name || ''));
    }, [avatar, data]);

    const getPresenterDrivers = async (avatar: Presenter | undefined): Promise<IClipDriver[]> => {
        if (!avatar) return [];

        try {
            const presenterDrivers = await getClipPresenterDrivers(avatar.id)();
            return presenterDrivers.sort((a, b) => (b?.name || '').localeCompare(a.name || ''));
        } catch (e) {
            return [];
        }
    };

    return { presenterDrivers, getPresenterDrivers };
};
